import React from 'react';
import {Link} from 'react-router-dom';
import {Row, Col} from 'react-bootstrap';
import '../styles/css/profile.css';
import {trackEvent} from '../util/tracking';

const Profile = (props) =>{
  return(
    <div>
      <Row className="title_row">
        <Col xs={12} className="text-center">
          <span>My Account</span>
        </Col>
      </Row>
      <Row className="text_row">
        <Col xs={12} md={10} mdOffset={1} className="text-center mypage">
          <span className="profile_line1">Musio EDGE会員情報は<Link to="https://www.themusio.com">themusio.com</Link> のホームページで合わせて管理しています。</span>
          <span className="profile_line2">会員情報及びパスワードの修正をご希望する場合は、下のリンクをクリックしてください。</span>
          <div>
            <a href="https://themusio.com/mypage/info" className="profile_link btn" onClick={() => trackEvent("SETTING", "Myaccount - Click Move To Themusio.com", "")}>themusio.comへ移動</a>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Profile;



// WEBPACK FOOTER //
// ./src/components/Profile.js